import React, { useState, useEffect, Fragment } from "react";
import PropTypes from "prop-types";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import clsx from "clsx";
import { useTheme } from "@material-ui/core/styles";
import InputAdornment from "@material-ui/core/InputAdornment";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import Typography from "@material-ui/core/Typography";
import Select from "@material-ui/core/Select";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import MenuItem from "@material-ui/core/MenuItem";
import Link from "@material-ui/core/Link";
import IconButton from "@material-ui/core/IconButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { i18n } from "~/i18n";
import { ValidatorForm, TextValidator } from "react-material-ui-form-validator";
import { CircularProgress, Hidden } from "@material-ui/core";
import { withTranslation } from "react-i18next";
import useStyles from "./footer-style";
import link from "../../static/text/link";
import Button from "../Button";
import { subscribeNews } from "../../helpers/api";
import styles from "../Featured/styles";
import { getCFCountry } from "../../helpers/setCookie";

const flagId = require("../../static/images/mfs/flag_id.png");
const flagEn = require("../../static/images/mfs/flag_us.png");

function Footer(props) {
  const classes = useStyles();
  const theme = useTheme();
  const {
    invert, isWebView, t, ctnStyle, whiteContent, hideLanguageButton: hideLanguageButtonProp = false
  } = props;
  const [hideLanguageButtonState, setHideLanguageButtonState] = useState(false);
  useEffect(() => {
    const cfCountry = getCFCountry();
    const isOutsideIndonesia = cfCountry && String(cfCountry).toUpperCase() !== "ID";
    setHideLanguageButtonState(!!isOutsideIndonesia);
  }, []);
  const hideLanguageButton = hideLanguageButtonProp || hideLanguageButtonState;
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const [values, setValues] = useState({
    lang: "en",
    email: "",
    responseStatus: "",
    textResponse: ""
  });
  const footers = [
    {
      title: t("about"),
      description: [t("about_us"), t("contact_us")],
      link: [link.mobile.static("about"), link.mobile.static("contact-us")],
    },
    {
      title: t("features"),
      description: !isMobile ? [t("articles"), t("food_database_show"), t("motivasi"), t("community"), t("fit_tools")] : [],
      link: [link.mobile.articles, link.mobile.foodDatabase, link.mobile.downloadAppRoot, link.mobile.downloadAppRoot, link.mobile.tools],
    },
    {
      title: t("legal"),
      description: [t("privacy_policy"), t("terms_of_use"), "Cookie Policy", t("refund_policy"), t("washington_health_data_policy"), t("nevada_health_data_policy")],
      link: [link.mobile.static("privacy-policy"), link.mobile.static("terms-of-use"), link.mobile.static("cookie-policy"), link.mobile.static("refund-policy"), link.mobile.static("consumer-health-data-privacy"), link.mobile.static("nevada-health-data-policy")],
    },
  ];

  useEffect(() => {
    setValues({ lang: i18n.language });
  }, []);

  function handleChange(event) {
    setValues(oldValues => ({
      ...oldValues,
      [event.target.name]: event.target.value,
    }));
    // if (event.target.value === 'ar') {
    //   i18n.changeLanguage('ar');
    //   props.toggleDir('rtl');
    // } else {
    //   i18n.changeLanguage(event.target.value);
    //   props.toggleDir('ltr');
    // }
    window.location.href = `/lang/${event.target.value}`;
  }

  const handleChangeInput = name => event => {
    setValues({
      ...values, [name]: event.target.value, responseStatus: "", textResponse: ""
    });
  };

  const setSubscribeNews = async () => {
    try {
      if (values.email) {
        setLoadingSubmit(true);
        const params = {
          email: values.email,
          language_code: values.lang
        };

        const res = await subscribeNews(params);
        setValues({ ...values, email: "", responseStatus: "success" });
        setLoadingSubmit(false);
        setTimeout(() => {
          setValues({ ...values, responseStatus: "", textResponse: "" });
        }, 1000 * 10);
      } else {
        setValues({ ...values, responseStatus: "null" });
        setTimeout(() => {
          setValues({ ...values, responseStatus: "", textResponse: "" });
        }, 1000 * 10);
      }
    } catch (err) {
      setLoadingSubmit(false);
      setValues({ ...values, responseStatus: "error", textResponse: err.data.data.email[0] });
    }
  };

  const handleTextError = (status) => {
    if (status === "success") {
      return t("success_enter_email");
    }
    if (status === "null") {
      return t("email_required");
    }
    if (status === "error") {
      return values.textResponse;
    }
    return "";
  };

  function getColorText() {
    if (whiteContent) {
      return classes.blackText;
    }
    return "";
  }

  function getIGLink() {
    if (values.lang === "en") {
      return link.mobile.mfsInstagram;
    }
    return link.mobile.mfsInstagramId;
  }
  function getFacebookLink() {
    if (values.lang === "en") {
      return link.mobile.mfsFacebook;
    }
    return link.mobile.mfsFacebookId;
  }


  const showLanguage = (getCFCountry() === 'ID' || !!getCFCountry() === false);
  return (
    <Container
      component="footer"
      className={clsx(classes.footer, invert && classes.invert, ctnStyle)}
    >
      <Grid container spacing={4} className={classes.spacingStyle}>
        <Grid item xs={12} md={6} className={classes.footerMobileOuter}>
          {/* {Place here subscribe news letter } */}
          <Grid item className={clsx(classes.containerSubscribe)}>
            <Typography variant="h6" className={clsx(classes.title, classes.nullMarginBototm, getColorText())} color="textPrimary" gutterBottom>
              {t("subscribe_to_newsletter")}
            </Typography>
            <Hidden smDown>
              <Typography variant="h6" className={clsx(classes.descriptionTitle, classes.titleCostum, getColorText())}>
                {t("subscribe_desc")}
              </Typography>
            </Hidden>
            <Hidden mdUp>
              <Typography variant="h6" className={clsx(classes.descriptionTitle, getColorText())}>
                {`${t("m_sub_desc1")} ${t("m_sub_desc2")}`}
              </Typography>
            </Hidden>
            <Grid container alignItems="center" justify="space-between" className={classes.containerForm}>
              <div className={classes.emailContainer}>
                <ValidatorForm onSubmit={setSubscribeNews}>
                  <TextValidator
                    variant="filled"
                    className={classes.input}
                    label={t("enter_email")}
                    value={values.email}
                    onChange={handleChangeInput("email")}
                    name="email"
                  />
                </ValidatorForm>
                <Hidden mdUp>
                  {values.responseStatus !== "" && <Typography variant="subtitle2" className={clsx(classes.textSuccess, values.responseStatus === "error" || values.responseStatus === "null" ? classes.errorText : undefined)}>{handleTextError(values.responseStatus)}</Typography>}
                </Hidden>
              </div>
              <Button styles={classes.btnStyle} isSubmitted={loadingSubmit} onClick={setSubscribeNews} gradient>{t("subscribe")}</Button>
            </Grid>
            <Hidden smDown>
              {values.responseStatus !== "" && <Typography variant="subtitle2" className={clsx(classes.textSuccess, values.responseStatus === "error" || values.responseStatus === "null" ? classes.errorText : undefined)}>{handleTextError(values.responseStatus)}</Typography>}
            </Hidden>
          </Grid>
          <Grid container spacing={4} justify="space-evenly">
            {footers.map(footer => (
              <Grid item xs={12} md={3} key={footer.title} className={clsx(classes.siteMapItem, invert && classes.invert, whiteContent && classes.ctnLinkWhiteContent)}>
                {isDesktop && (
                  <div>
                    <Typography variant="h6" className={clsx(classes.title, getColorText())} color="textPrimary" gutterBottom>
                      {footer.title}
                    </Typography>
                    <ul>
                      {footer.description.map((item, index) => (
                        <li key={item}>
                          <Link href={footer.link[index]} variant="subtitle1">
                            {item}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
                {/* {isMobile && (
                  <ExpansionPanel
                    square
                    className={invert ? classes.invert : ''}
                    classes={{
                      root: classes.accordionRoot,
                    }}
                  >
                    <ExpansionPanelSummary
                      expandIcon={<ExpandMoreIcon className={classes.accordionIcon} />}
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                      classes={{
                        content: classes.accordionContent,
                      }}
                    >
                      <strong>
                        {footer.title}
                      </strong>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails>

                    </ExpansionPanelDetails>
                  </ExpansionPanel>
                )} */}
                {isMobile && (
                  <ul>
                    {footer.description.map((item, index) => (
                      <li key={item}>
                        <Link href={footer.link[index]} variant="subtitle1" color="textSecondary">
                          {item}
                        </Link>
                      </li>
                    ))}
                  </ul>
                )}
              </Grid>
            ))}
          </Grid>
        </Grid>
        <Grid item xs={12} md={3}>
          {!isWebView && (
            <Fragment>
              <div className={classes.socmed}>
                <IconButton aria-label="FB" className={classes.margin} size="small" href={link.mobile.mfsTwitter} target="_blank">
                  <FontAwesomeIcon icon={["fab", "twitter"]} />
                </IconButton>
                <IconButton aria-label="TW" className={classes.margin} size="small" href={getFacebookLink()} target="_blank">
                  <FontAwesomeIcon icon={["fab", "facebook"]} />
                </IconButton>
                <IconButton aria-label="IG" className={classes.margin} size="small" href={getIGLink()} target="_blank">
                  <FontAwesomeIcon icon={["fab", "instagram"]} />
                </IconButton>
                <IconButton aria-label="LI" className={classes.margin} size="small" href={link.mobile.mfsPinterest} target="_blank">
                  <FontAwesomeIcon icon={["fab", "pinterest"]} />
                </IconButton>
              </div>
              {showLanguage && !hideLanguageButton && (
                <Select
                  value={values.lang}
                  onChange={handleChange}
                  startAdornment={(
                    <InputAdornment className={classes.icon} position="start">
                      <img src={values.lang === "en" ? flagEn : flagId} alt="flag" />
                    </InputAdornment>
                  )}
                  className={clsx(classes.selectLang, whiteContent && classes.ctnSelectWhite)}
                  input={<OutlinedInput labelWidth={220} name="lang" id="outlined-lang-simple" />}
                >
                  <MenuItem value="en">{t("english")}</MenuItem>
                  <MenuItem value="id">{t("indonesian")}</MenuItem>
                </Select>
              )}
            </Fragment>
          )}
        </Grid>
      </Grid>
    </Container>
  );
}

Footer.propTypes = {
  t: PropTypes.func.isRequired,
  invert: PropTypes.bool,
  isWebView: PropTypes.bool,
  ctnStyle: PropTypes.string,
  hideLanguageButton: PropTypes.bool,
};

Footer.defaultProps = {
  invert: false,
  toggleDir: () => { },
  isWebView: false,
  ctnStyle: "",
  hideLanguageButton: false,
};

export default withTranslation(["myfitsociety"])(Footer);
